import * as actionsType from './types';


export const setShowLogIn = (show) => async dispatch => {
  dispatch({type: actionsType.SET_SHOW_LOGIN,show: show});
}
// channel (optional): "EMAIL" (default) or "WHATSAPP" — which tab the send-message modal opens on
export const setShowSendMassage = (show,list,channel) => async dispatch => {
  dispatch({type: actionsType.SET_SHOW_SEND_MASSAGE,show: show ,sendMassageCustomersList: list||"", sendMassageChannel: channel||"EMAIL"});
}
export const setShowListAdder = (show,listName) => async dispatch => {
  dispatch({type: actionsType.SET_SHOW_LIST_ADDER,show: show ,listName:listName});
}
export const setShowSpinner = (show,progressBarCounter,progressBarCounterEnd) => async dispatch => {
  dispatch({type: actionsType.SET_SHOW_SPINNER,show: show,progressBarCounter:progressBarCounter,progressBarCounterEnd:progressBarCounterEnd});
}